import React from 'react'

function OpenIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={18}
      height={24}
      fill="none"
      {...props}
    >
      <path
        fill="#56565A"
        fillRule="evenodd"
        d="M15.077 11.41A.834.834 0 0 1 16.5 12v5a2.5 2.5 0 0 1-2.5 2.5H4A2.5 2.5 0 0 1 1.5 17V7A2.5 2.5 0 0 1 4 4.5h5a.833.833 0 0 1 0 1.667H4A.833.833 0 0 0 3.167 7v10a.833.833 0 0 0 .833.833h10a.834.834 0 0 0 .833-.833v-5c0-.221.088-.433.244-.59ZM13.65 6.168h-1.317a.833.833 0 0 1 0-1.667h3.334a.833.833 0 0 1 .833.833v3.334a.833.833 0 1 1-1.667 0V7.35l-5.241 5.233a.833.833 0 0 1-1.184 0 .832.832 0 0 1 0-1.183l5.242-5.233Z"
        clipRule="evenodd"
      />
    </svg>
  )
}

export default OpenIcon
